import { get } from "../../service/api";

const GetBankTransactionLog = async (queryString) => {
  try {
    const response = await get(`/admin/bankTransactionLog?1=1&${queryString}`);
    return response;
  } catch (error) {
    console.error("Error GetBankTransactionLog:", error);
    throw error;
  }
};

export default GetBankTransactionLog;
